import { render } from "./VerifiedEmail.vue?vue&type=template&id=7424fc8f"
import script from "./VerifiedEmail.vue?vue&type=script&lang=js"
export * from "./VerifiedEmail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/virayadak-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__